import { useFormContext } from 'react-hook-form';
import { TicketTypePriorityInput } from 'src/components/common/TicketTypePriorityInput';
import { Content } from 'src/contexts/ContentContext';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Detail, DetailGroup } from 'src/modals/common';
import { ContentId } from 'src/utils/constants/contentId';
import {
  DeliveryType,
  Feature,
  ListingDetailsUpdateInput,
} from 'src/WebApiController';

export const TicketTypePrioritySection = ({
  deliveryType,
  disabled,
  confirmUpdateSales,
}: {
  deliveryType: DeliveryType | null;
  disabled: boolean;
  confirmUpdateSales: () => void;
}) => {
  const { watch, setValue } = useFormContext<ListingDetailsUpdateInput>();
  const isMobile = useMatchMedia('mobile');
  const ticketTypeRules = watch('ticketTypeRules');
  const hasBackfillTicketTypeOverrideToSaleFeature = useUserHasFeature(
    Feature.BackfillListingTicketTypeOverrideToSale
  );

  return (
    <DetailGroup style={{ gridColumn: isMobile ? 1 : '1 / span 2' }}>
      <Detail
        label={<Content id={ContentId.DeliveryStrategy} />}
        style={{ flex: 1 }}
        detail={
          <>
            <TicketTypePriorityInput
              deliveryType={deliveryType}
              ticketTypeRules={ticketTypeRules}
              onTicketTypeRulesChange={(newRules) => {
                setValue('ticketTypeRules', newRules);

                if (hasBackfillTicketTypeOverrideToSaleFeature) {
                  confirmUpdateSales();
                }
              }}
              disabled={disabled}
            />
          </>
        }
      />
    </DetailGroup>
  );
};
